import _ from "lodash";
import { Module } from "@/models/module";

export default {
  setModule(
    state: any,
    payload: {
      type: string;
      modules: Array<Module>;
      currentPage: number;
      total: number;
    }
  ) {
    if (!state[payload.type].length) {
      state[payload.type] = payload.modules;
    } else {
      state[payload.type] = state[payload.type].concat(payload.modules);
    }

    state["loaded"][payload.type] = state[payload.type].length >= payload.total;
    state["currentPage"][payload.type] = payload.currentPage;
  },
  resetPage(
    state: any,
    payload: {
      moduleType: string;
    }
  ) {
    const _moduleType = payload.moduleType.toLowerCase();
    state["currentPage"][_moduleType] = 0;
    state["loaded"][_moduleType] = false;
    state[_moduleType] = [];
  },
  clearState(state: any) {
    _.forEach(Object.keys(state), (key: string) => {
      state[key] = [];
    });
  },
  setSearching(
    state: any,
    payload: {
      type: string;
      modules: Array<Module>;
      total: number;
      search: string;
    }
  ) {
    if (!state["searching"][payload.type].values.length) {
      state["searching"][payload.type].values = payload.modules;
    } else {
      state["searching"][payload.type].values = state["searching"][
        payload.type
      ].values.concat(payload.modules);
    }

    state["searching"].search = payload.search;
    state["searching"][payload.type].total = payload.total;
  },
  cleanSearching(state: any, payload: { type: string }) {
    if (state["searching"][payload.type] !== undefined) {
      state["searching"][payload.type].values = [];
      state["searching"][payload.type].total = 0;
    }
  },
  removeModule(
    state: any,
    payload: {
      type: string;
      moduleId: string;
    }
  ) {
    if (state[payload.type].length) {
      state[payload.type] = state[payload.type].filter(
        (content: Module) => content.id !== payload.moduleId
      );
    }
  },
  addModule(
    state: any,
    payload: {
      type: string;
      module: Module;
    }
  ) {
    if (state[payload.type].length) {
      state[payload.type].push(payload.module);
      state["currentPage"][payload.type] =
        state["currentPage"][payload.type] + 1;
    }
  },
  updateModule(
    state: any,
    payload: {
      type: string;
      module: Module | any;
    }
  ) {
    if (!state[payload.type]) {
      return;
    }
    if (!state[payload.type].length) {
      return;
    } else {
      const moduleIndex = state[payload.type].findIndex(
        (module: any) =>
          module.id == payload.module.module?.moduleId ||
          payload.module.moduleId == module.id
      );
      if (moduleIndex !== -1) {
        state[payload.type][moduleIndex] = payload.module;
      }
    }
  },
};
